/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Save_ButtonInputs */



/**
* | output |
* | --- |
* | "Save Metadata" |
*
* @param {Event_Group_Metadata_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_save_button = /** @type {((inputs?: Event_Group_Metadata_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить метаданные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar metadados")
	return /** @type {LocalizedString} */ ("Save Metadata")
});